import { keyframes } from 'tss-react';
import { makeStyles } from 'tss-react/mui';

interface IProps {
  size?: number;
  testId?: string;
}

const spinner1 = keyframes({
  '0%': {
    transform: 'scale(0)',
  },
  '100%': {
    transform: 'scale(1)',
  },
});

const spinner3 = keyframes({
  '0%': {
    transform: 'scale(1)',
  },
  '100%': {
    transform: 'scale(0)',
  },
});

const spinnerTranslate = keyframes({
  '0%': {
    transform: 'translate(0, 0)',
  },
  '100%': {
    transform: 'translate(0.75em, 0)',
  },
});
const useStyles = makeStyles()(theme => ({
  spinnercontainer: {
    display: 'inline-block',
    position: 'absolute',
    left: 'calc(50% - 1.25em)',
    top: 'calc(50% - 0.5em)',
    fontSize: '12px',
  },
  spinnerWrapper: {
    display: 'inline-block',
    position: 'relative',
    width: '2.5em',
    height: '1em',
  },
  dot: {
    display: 'block',
    position: 'absolute',
    top: '0.25em',
    width: '0.5em',
    height: '0.5em',
    borderRadius: '50%',
    background: theme.customProperties.Legend.orange.full,
    animationDuration: '0.6s',
    animationIterationCount: 'infinite',
    animationDirection: 'normal',
    animationTimingFunction: 'ease-in-out',
  },
  dot1: {
    left: '0.25em',
    animationName: `${spinner1}`,
  },
  dot2: {
    left: '0.25em',
    animationName: `${spinnerTranslate}`,
  },
  dot3: {
    left: '1em',
    animationName: `${spinnerTranslate}`,
  },
  dot4: {
    left: '1.75em',
    animationName: `${spinner3}`,
  },
}));

export const EDAvenyProgressSmall = (props: IProps) => {
  const { classes, cx } = useStyles();
  const size: string = props.size ? props.size / 4 + 'px' : '12px';
  return (
    <div
      className={cx(classes.spinnercontainer)}
      style={{ fontSize: size }}
      data-testid={props.testId}
    >
      <div className={cx(classes.spinnerWrapper)}>
        <span className={cx(classes.dot, classes.dot1)}></span>
        <span className={cx(classes.dot, classes.dot2)}></span>
        <span className={cx(classes.dot, classes.dot3)}></span>
        <span className={cx(classes.dot, classes.dot4)}></span>
      </div>
    </div>
  );
};

export default EDAvenyProgressSmall;
